<template>
    <div>
        <rkm-row>

            <rkm-col cols="2">
                <rkm-area
                    title="Turno *"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                name="Turno"
                                :options="data.form.turnos"
                                :label="false"
                                :disabled="isAmbulatorio"
                                show-default-option
                                text-field="nome"
                                v-model="data.model.atendimento.turnoId"
                                :validations="validations.turno"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Local de atendimento *"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                name="Local de atendimento"
                                :options="data.form.localAtendimento"
                                :label="false"
                                :disabled="isAmbulatorio"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.localAtendimentoId"
                                :validations="validations.localAtendimento"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Tipo de atendimento *"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                name="Tipo de atendimento"
                                :options="data.form.tipoAtendimento"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.tipoAtendimentoId"
                                :validations="validations.tipoAtendimento"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                                @change="handleTipoAtendimento()"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-area
                    title="Vacinação"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                            v-model="data.model.atendimento.vacinacao"
                                label="Está em dia?"
                                class="mb-0 pb-0"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Atenção domiciliar"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.atencaoDomiciliar"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.modalidadeAtencaoDomiciliarId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Criança - Aleitamento materno"
                    no-margin-top
                >

                <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.aleitamentoMaterno"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.aleitamentoMaternoId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                                />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Racionalidade em saúde (Exceto alopatia / convencional)"
                    no-margin-top
                    >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.racionalidadeSaude"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.atendimento.racionalidadeSaudeId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Medições"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.circunferenciaAbdominal"
                                append="cm"
                                label="Circunferência abdominal"
                                placeholder="000"
                                v-mask="masks.circunferenciaAbdominal"
                                v-model="data.model.atendimento.circunferenciaAbdominal"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.perimetroPanturrilha"
                                append="cm"
                                label="Perímetro da panturrilha"
                                placeholder="00"
                                v-mask="masks.perimetroPanturrilha"
                                v-model="data.model.atendimento.perimetroPanturrilha"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.pressaoArterial"
                                label="Pressão arterial"
                                placeholder="000/000"
                                v-mask="'###/###'"
                                v-model="data.model.atendimento.pressaoArterial"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        mmHg
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.frequenciaRespiratoria"
                                label="Frequência respiratória"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="data.model.atendimento.frequenciaRespiratoria"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        mpm
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.frequenciaCardiaca"
                                label="Frequência cardíaca"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="data.model.atendimento.frequenciaCardiaca"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        bpm
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.temperatura"
                                label="Temperatura"
                                placeholder="00,0"
                                v-mask="'##.#'"
                                v-model="data.model.atendimento.temperatura"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        °C
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.saturacaoO2"
                                label="Saturação de O2"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="data.model.atendimento.saturacaoO2"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        %
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.peso"
                                append="kg"
                                label="Peso"
                                placeholder="000.00"
                                v-mask="pesoMask"
                                v-model="data.model.atendimento.peso"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.altura"
                                append="cm"
                                label="Altura"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="data.model.atendimento.altura"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.perimetroCefalico"
                                append="cm"
                                label="Perímetro cefálico"
                                placeholder="000.0"
                                v-mask="masks.perimetroCefalico"
                                v-model="data.model.atendimento.perimetroCefalico"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :validations="validations.glicemia"
                                label="Glicemia capilar"
                                placeholder="000"
                                v-mask="masks.glicemia"
                                v-model="data.model.atendimento.glicemia"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        mg/dL
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col>

                            <rkm-form-select
                                :options="data.form.momentosColeta"
                                :validations="validations.momentoColeta"
                                label="Momento da coleta"
                                show-default-option
                                text-field="nome"
                                v-model="data.model.atendimento.momentoColetaId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12" v-if="data.model.cidadao.sexoId == this.enums.sexo.FEMININO && !this.getIdade()">
                <rkm-area
                    title="Gestante"
                    type="fieldset"
                    no-margin-top
                    >

                    <rkm-button
                        @click="$refs.ModalGestante.open()"
                        color="primary"
                        slot="trailing"
                        small
                        title="Histórico"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-row>

                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                    label="DUM"
                                    :max-date="data.form.dataAtual"
                                    :min-date="minDateDum"
                                    v-model="data.model.atendimento.dum"
                                    :validations="validations.dum"
                                    right
                                />
                            </rkm-col>

                        <rkm-col cols="4">

                            <rkm-form-group
                                label-for="Idade gestacional"
                                label="Idade gestacional"
                                class="mb-0"
                            >
                                <rkm-row>
                                    <rkm-col cols="6">
                                        <rkm-form-input
                                            append="Semanas"
                                            name="Semanas"
                                            v-model="data.model.atendimento.idadeGestacionalSemanas"
                                            :validations="validations.semanas"
                                            number
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <rkm-form-input
                                            append="Dias"
                                            name="Dias"
                                            v-model="data.model.atendimento.idadeGestacionalDias"
                                            :validations="validations.dias"
                                            number
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-form-group>
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-date-picker
                                label="DPP"
                                v-model="data.model.atendimento.dataPossivelParto"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-radio-group
                                v-model="data.model.atendimento.gravidezPlanejada"
                                label="Gravidez planejada"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                label="Gestações prévias"
                                v-model="data.model.atendimento.gestacaoPrevia"
                                :validations="validations.gestacoesPrevias"
                                number
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                label="Partos"
                                v-model="data.model.atendimento.parto"
                                :validations="validations.partos"
                                number
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    :title="`Problema / Condição avaliada ${isAvaliacaoRequired ? '*' : ''}`"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">

                            <rkm-form-checkbox-group
                                v-model="data.model.atendimento.condicaoAvaliada"
                                :validations="validations.condicaoAvaliada"
                                name="Condição avaliada"
                            >
                                <rkm-form-checkbox
                                    v-for="condicao in data.form.condicaoAvaliada"
                                    :key="condicao.id"
                                    :value="condicao.id"
                                    class="w-25 m-0"
                                    :disabled="isDisabledCondicao(condicao.id)"
                                >
                                    {{ condicao.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-area
                                title="Doenças transmissíveis"
                                no-margin-top
                            >

                                <rkm-row>

                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            v-model="data.model.atendimento.doencaTransmissivel"
                                            :validations="validations.doencaTransmissivel"
                                            name="Doenças transmissíveis"
                                        >
                                            <rkm-form-checkbox
                                                v-for="doencao in data.form.doencaTransmissivel"
                                                :key="doencao.id"
                                                :value="doencao.id"
                                                class="w-25 m-0"
                                            >
                                                {{ doencao.descricao }}
                                            </rkm-form-checkbox>
                                        </rkm-form-checkbox-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-area
                                title="Rastreamento"
                                no-margin-top
                            >

                                <rkm-row>

                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            v-model="data.model.atendimento.rastreamento"
                                            :validations="validations.rastreamento"
                                            name="Rastreamento"
                                        >
                                            <rkm-form-checkbox
                                                v-for="rastreamento in data.form.rastreamento"
                                                :key="rastreamento.id"
                                                :value="rastreamento.id"
                                                :disabled="isDisabledRastreamento(rastreamento.id)"
                                                class="w-25 m-0"
                                            >
                                                {{ rastreamento.descricao }}
                                            </rkm-form-checkbox>
                                        </rkm-form-checkbox-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-area
                                title="Outros"
                                no-margin-top
                            >
                                <template
                                    slot="trailing"
                                >
                                    <rkm-button
                                        @click="$refs.ModalProblemaCondicao.open()"
                                        color="primary"
                                        small
                                        title="Adicionar"
                                    >
                                        <rkm-icon icon="plus" />
                                    </rkm-button>
                                </template>

                                <rkm-row>
                                    <rkm-col cols="12">
                                        <ListProblemaCondicao
                                            :data="data"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">

                <rkm-area
                    title="Exames Solicitados(S) e Avaliados(A)"
                    type="fieldset"
                    no-margin-top
                >
                    <rkm-form-checkbox-group v-model="data.model.atendimento.exameSolicitadoAvaliado">

                        <rkm-row>

                            <rkm-col
                                class="d-flex align-items-center"
                                v-for="rastreamento in data.form.exameSolicitadoAvaliado"
                                :key="rastreamento.id"
                                cols="6"
                            >

                                <div class="mr-2">
                                    <rkm-form-checkbox
                                        :value="'s_' + rastreamento.id"
                                        class="m-0"
                                        :disabled="handleAvaliadoSolicitado && !isChecked(rastreamento.id, 'rastreamento')"
                                    >
                                        S
                                    </rkm-form-checkbox>
                                </div>

                                <rkm-form-checkbox
                                    :value="'a_' + rastreamento.id"
                                    class="w-100 m-0"
                                    :disabled="handleAvaliadoSolicitado && !isChecked(rastreamento.id, 'rastreamento')"
                                >
                                    A - {{ rastreamento.descricao }}
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-area
                                    title="Triagem neonatal"
                                    no-margin-top
                                >

                                    <rkm-form-checkbox-group
                                        v-model="data.model.atendimento.triagemNeonatal"
                                    >

                                        <rkm-row>

                                            <rkm-col
                                                class="d-flex align-items-center"
                                                v-for="triagem in data.form.triagemNeonatal"
                                                :key="triagem.id"
                                                cols="4"
                                            >

                                                <div class="mr-2">
                                                    <rkm-form-checkbox
                                                        :value="'s_' + triagem.id"
                                                        class="m-0"
                                                        :disabled="handleAvaliadoSolicitado && !isChecked(triagem.id, 'triagemNeonatal')"
                                                    >
                                                        S
                                                    </rkm-form-checkbox>
                                                </div>

                                                <rkm-form-checkbox
                                                    :value="'a_' + triagem.id"
                                                    class="w-100 m-0"
                                                    :disabled="handleAvaliadoSolicitado&& !isChecked(triagem.id, 'triagemNeonatal')">
                                                    A - {{ triagem.descricao }}
                                                </rkm-form-checkbox>
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-form-checkbox-group>
                                </rkm-area>
                            </rkm-col>

                            <rkm-col cols="12">

                                <rkm-area
                                    title="Outros exames"
                                >

                                    <rkm-button
                                        @click="$refs.Modal.open()"
                                        color="primary"
                                        slot="trailing"
                                        small
                                        title="Adicionar"
                                        :disabled="handleAvaliadoSolicitado"
                                    >
                                        <rkm-icon icon="plus" />
                                    </rkm-button>

                                    <rkm-table
                                        :fields="fields.table"
                                        :items="data.model.atendimento.outrosExames"
                                        hide-filters
                                        hide-pagination
                                    >

                                        <template v-slot:cell(exameNome)="{ item }">
                                            {{ item.codigo }} - {{ item.exameNome }}
                                        </template>

                                        <template v-slot:cell(solicitado)="{ item }">
                                            {{ item.solicitado ? 'SIM' : 'NÃO' }}
                                        </template>

                                        <template v-slot:cell(avaliado)="{ item }">
                                            {{ item.avaliado ? 'SIM' : 'NÃO' }}
                                        </template>

                                        <template v-slot:cell(actions)="{ index, item }">
                                            <rkm-button
                                                @click="$refs.Modal.open(index, item)"
                                                color="primary"
                                                small
                                                title="Editar"
                                            >
                                                <rkm-icon icon="pen" />
                                            </rkm-button>

                                            <rkm-button
                                                @click="destroy(index)"
                                                color="danger"
                                                small
                                                title="Excluir"
                                            >
                                                <rkm-icon icon="trash" />
                                            </rkm-button>
                                        </template>
                                    </rkm-table>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Ficou em observação?"
                    type="fieldset"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                v-model="data.model.atendimento.observacao"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="EMULTI / Polo"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">

                            <rkm-form-checkbox-group v-model="data.model.atendimento.nasf">
                                <rkm-form-checkbox
                                    v-for="nasf in data.form.nasf"
                                    :key="nasf.id"
                                    :value="nasf.id"
                                    class="w-50 m-0"
                                >
                                    {{ nasf.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    :title="`Conduta / Desfecho ${data.model.atendimento.conduta.length === 0 && data.model.atendimento.encaminhamento.length === 0? '*' : ''}`"
                    no-margin-top
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="12">

                            <rkm-form-checkbox-group
                                v-model="data.model.atendimento.conduta"
                                :validations="validations.conduta"
                                name="Conduta / Desfecho"
                            >
                                <rkm-form-checkbox
                                    v-for="conduta in data.form.conduta"
                                    :key="conduta.id"
                                    :value="conduta.id"
                                    class="w-50 m-0"
                                >
                                    {{ conduta.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>

                        </rkm-col>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Encaminhamento"
                                no-margin-top
                            >

                                <rkm-row>

                                    <rkm-col cols="12">

                                        <rkm-form-checkbox-group
                                            v-model="data.model.atendimento.encaminhamento"
                                            :validations="validations.encaminhamento"
                                            name="Encaminhamento"
                                        >
                                            <rkm-form-checkbox
                                                v-for="encaminhamento in data.form.encaminhamento"
                                                :key="encaminhamento.id"
                                                :value="encaminhamento.id"
                                                class="w-50 m-0"
                                            >
                                                {{ encaminhamento.descricao }}
                                            </rkm-form-checkbox>
                                        </rkm-form-checkbox-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalGestante
            :items="data.form.gestante"
            ref="ModalGestante"
        />

        <ModalProblemaCondicao
            :data="data"
            ref="ModalProblemaCondicao"
        />
    </div>
</template>

<script>

//Moment
import moment from 'moment'

//Enums
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'
import sexo from '@/enums/cadastro/cidadao/sexo'
import condicaoAvaliada from '@/enums/atencao-basica/atendimento-individual/condicaoAvaliada'
import rastreamento from '@/enums/atencao-basica/atendimento-individual/rastreamento'
import exameSolicitadoAvaliado from '@/enums/atencao-basica/atendimento-individual/exameSolicitadoAvaliado'
import ciapHipertensao from '@/enums/atencao-basica/atendimento-individual/ciapHipertensao'
import ciapGravidez from '@/enums/atencao-basica/atendimento-individual/ciapGravidez'
import cidHipertensao from '@/enums/atencao-basica/atendimento-individual/cidHipertensao'
import cidGravidez from '@/enums/atencao-basica/atendimento-individual/cidGravidez'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import procedimento from '@/enums/sigtap/procedimento'

// Mixins
import { repository, object, formats, mask, data } from '@/mixins'

// Components.
import Modal from './Modal'
import ModalGestante from './components/gestante/Modal'
import ListProblemaCondicao from './components/problema-condicao/List'
import ModalProblemaCondicao from './components/problema-condicao/Modal'

export default {
    components: { Modal, ModalGestante, ListProblemaCondicao, ModalProblemaCondicao },
    mounted() {
        if (this.data.model.atendimento.dum) {
            this.data.model.atendimento.dum = new Date(this.data.model.atendimento.dum)
            this.getGestacao()
            this.getDataProvavelParto()
        }
    },
    computed: {
        autocompleteRequestParams() {
            return {
                ciap1: {
                    sexo_id: this.data.model.cidadao.sexoId,
                    ciap_id: this.data.model.atendimento.ciap2 ? this.data.model.atendimento.ciap2.id : null,
                },
                ciap2: {
                    sexo_id: this.data.model.cidadao.sexoId,
                    ciap_id: this.data.model.atendimento.ciap1 ? this.data.model.atendimento.ciap1.id : null,
                },
                cid1: {
                    sexo: this.data.model.cidadao.sexoId
                        ? this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                    cid_id: this.data.model.atendimento.cid2 ? this.data.model.atendimento.cid2.id : null,
                },
                cid2: {
                    sexo: this.data.model.cidadao.sexoId
                        ? this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                    cid_id: this.data.model.atendimento.cid1 ? this.data.model.atendimento.cid1.id : null,
                },
            }
        },
        validations() {

            return {
                turno: { required: true },
                localAtendimento: { required: true },
                tipoAtendimento: { required: true },
                conduta: { required: this.data.model.atendimento.encaminhamento && this.data.model.atendimento.encaminhamento.length === 0 ? true : false },
                encaminhamento: { required: this.data.model.atendimento.conduta && this.data.model.atendimento.conduta.length === 0 ? true : false },
                perimetroCefalico: { min_value: 10, max_value: 200 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                semanas: { min_value: 1, max_value: 42 },
                dias: { max_value: 6 },
                gestacoesPrevias: { max: 2 },
                partos: { max: 2 },
                condicaoAvaliada: { required: this.isAvaliacaoRequired },
                doencaTransmissivel: { required: this.isAvaliacaoRequired },
                rastreamento: { required: this.isAvaliacaoRequired },
                ciap1: { required: this.isAvaliacaoRequired },
                ciap2: { required: this.isAvaliacaoRequired },
                cid1: { required: this.isAvaliacaoRequired },
                cid2: { required: this.isAvaliacaoRequired },
                dum: { required: this.isDumRequired ? true : false },
                glicemia: { required: this.data.model.atendimento.momentoColetaId ? true : false, min_value: 0, max_value: 800 },
                momentoColeta: { required: this.data.model.atendimento.glicemia ? true : false },
                circunferenciaAbdominal: { max_value: 999 },
                perimetroPanturrilha: { min_value: 10, max_value: 99 },
                frequenciaRespiratoria: { min_value: 0, max_value: 200 },
                frequenciaCardiaca: {max_value: 999},
                temperatura: { min_value: 20, max_value: 45 },
                saturacaoO2: { min_value: 0, max_value: 100 },
            }
        },
        isAvaliacaoRequired() {

            return this.data.model.atendimento.condicaoAvaliada.length === 0
                && this.data.model.atendimento.doencaTransmissivel.length === 0
                && this.data.model.atendimento.rastreamento.length === 0
                && this.data.model.atendimento.problemasCondicoes.length === 0
        },
        isDumRequired() {

            return this.data.model.atendimento.condicaoAvaliada.includes(this.enums.condicaoAvaliada.PRE_NATAL)
                || this.data.model.atendimento.ciap1 && Object.values(this.enums.ciapGravidez).includes(this.data.model.atendimento.ciap1.id)
                || this.data.model.atendimento.ciap2 && Object.values(this.enums.ciapGravidez).includes(this.data.model.atendimento.ciap2.id)
                || this.data.model.atendimento.cid1 && Object.values(this.enums.cidGravidez).includes(this.data.model.atendimento.cid1.id)
                || this.data.model.atendimento.cid2 && Object.values(this.enums.cidGravidez).includes(this.data.model.atendimento.cid2.id)
        },
        pesoMask() {

            const length = (this.data.model.atendimento.peso ?? '').replace('.', '').length

            if (length <= 3) {

                return '#.##'
            }
            else if (length <= 4) {

                return '##.##'
            }
            else {

                return '###.##'
            }
        },
        minDateDum() {

            return moment(this.data.model.cidadao.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        handleAvaliadoSolicitado() {

            const outrosExames = this.data.model.atendimento.outrosExames
            const exameSolicitadoAvaliado = this.data.model.atendimento.exameSolicitadoAvaliado
            const triagemNeonatal = this.data.model.atendimento.triagemNeonatal

            let total = 0

            if (triagemNeonatal) {

                triagemNeonatal.forEach((item, index) => {

                    let id = item.replace('s_', '').replace('a_', '')
                    let existe = triagemNeonatal.find((registro, i) => registro == id && i != index)

                    if (!existe) {
                        total++;
                    }
                });
            }

            if (exameSolicitadoAvaliado) {
                exameSolicitadoAvaliado.forEach((item, index) => {

                    let id = item.replace('s_', '').replace('a_', '')
                    let existe = exameSolicitadoAvaliado.find((registro, i) => registro == id && i != index)

                    if (!existe) {
                        total++;
                    }
                });
            }

            if (outrosExames) {
                outrosExames.forEach((item, index) => {

                    let id = item.exameId
                    let existe = outrosExames.find((registro, i) => registro == id && i != index)

                    if (!existe) {
                        total++;
                    }
                });
            }

            if (total >= 100) {
                return true;
            }

            return false;
        },
    },
    created() {

        this.repositories = {
            ciap: this.getConectaSusRepository('geral.ciap'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
            cadastroIndividual: this.getConectaSusRepository('atencaoBasica.cadastroIndividual'),
        }
    },
    data: () => ({
        items: [],
        enums: {
            saidaCidadao,
            sexo,
            condicaoAvaliada,
            rastreamento,
            ciapHipertensao,
            ciapGravidez,
            cidHipertensao,
            cidGravidez,
            tipoAtendimento,
            procedimento,
            exameSolicitadoAvaliado
        },
        masks: {
            altura: '###',
            circunferenciaAbdominal: '###',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##',
            peso: '###.##',
            glicemia: '###',
        },
        fields: {
            autocomplete: {
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                ciap: [
                    { key: 'codigo', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            },
            table: [
                {
                    key: "exameNome",
                    label: "Exame",
                },
                {
                    key: "solicitado",
                    label: "Solicitado",
                    class: "col-min",
                },
                {
                    key: "avaliado",
                    label: "Avaliado",
                    class: "col-min",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                comunidade: [
                    { key: 'codigoEsus', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            },
        },
    }),
    methods: {
        destroy(index) {

            const destroy = async () => this.data.model.atendimento.outrosExames.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o exame?', destroy)
        },
        getIdade() {
            const dataAtual = moment(this.data.form.dataAtual, 'DD/MM/YYYY');
            const idade = dataAtual.diff(moment(this.data.model.cidadao.dataNascimento,'DD/MM/YYYY'), 'years');

            if (idade < 9 && idade > 60) {

                this.data.model.condicao.gestante = false

                return true;
            }

            return false;
        },
        getGestacao() {

            const dataAtual = moment(this.data.form.dataAtual, 'DD/MM/YYYY');
            const diferenca = dataAtual - this.data.model.atendimento.dum;
            const diasTotais = Math.floor(diferenca / (1000 * 60 * 60 * 24));

            const semanasCompletas = Math.floor(diasTotais / 7);
            const diasRestantes = diasTotais % 7;

            this.data.model.atendimento.idadeGestacionalSemanas = semanasCompletas
            this.data.model.atendimento.idadeGestacionalDias = diasRestantes
        },
        getDataProvavelParto() {

            const dataUltimaMenstruacaoMoment = moment(this.data.model.atendimento.dum, 'YYYY-MM-DD');
            const dataProvavelPartoMoment = moment(dataUltimaMenstruacaoMoment).add(294, 'days');

            this.data.model.atendimento.dataPossivelParto = dataProvavelPartoMoment.format('YYYY-MM-DD');
        },
        resetGestante() {

            this.data.model.atendimento.idadeGestacionalSemanas = null
            this.data.model.atendimento.idadeGestacionalDias = null
            this.data.model.atendimento.gravidezPlanejada = null
            this.data.model.atendimento.dataPossivelParto = null
            this.data.model.atendimento.gestacaoPrevia = null
            this.data.model.atendimento.parto = null
        },
        isDisabledCondicao(condicaoId) {

            return (condicaoId == this.enums.condicaoAvaliada.PRE_NATAL || condicaoId == this.enums.condicaoAvaliada.PUERPERIO)
                && (this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
                    || (this.data.model.cidadao.sexoId == this.enums.sexo.FEMININO && this.getIdade()))
        },
        isDisabledRastreamento(rastreamentoId) {

            return rastreamentoId == this.enums.rastreamento.CANCER_COLO_UTERO
                && this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
        },
        handleExame(exame, acao) {

            const procedimento = this.data.model.atendimento.outrosExames
                .find((obj => obj.codigo == exame.codigoProcedimento));

            const param = {
                exameId: exame.id,
                exameNome: exame.descricao,
                codigo: exame.codigoProcedimento,
            }

            if (acao == 'avaliado') {
                param.avaliado = procedimento && procedimento.avaliado ? false : true
                param.solicitado = procedimento && procedimento.solicitado ? true : false
            } else {
                param.solicitado = procedimento && procedimento.solicitado ? false : true
                param.avaliado = procedimento && procedimento.avaliado ? true : false
            }

            const objId = this.data.model.atendimento.outrosExames
                .findIndex((obj => obj.codigo == exame.codigoProcedimento));

            if (objId >= 0) {

                if (param.solicitado || param.avaliado) {
                    this.$set(this.data.model.atendimento.outrosExames, objId, this.clone(param))
                } else {
                    this.data.model.atendimento.outrosExames.splice(objId, 1)
                }
            } else {

                this.data.model.atendimento.outrosExames.push(this.clone(param))
            }
        },
        isChecked(id, exames) {

            const checked = this.data.model.atendimento[exames].find(item => item === 'a_' + id || item === 's_' + id);
            return checked ? true : false;
        },
        handleTipoAtendimento() {

            if (this.data.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO) {

                this.showAlert(`Ao escolher a opção de atendimento 'Escuta inicial / Orientação', o procedimento
                    <strong>(0301040079 - ESCUTA INICIAL / ORIENTAÇÃO (ACOLHIMENTO A DEMANDA ESPONTÂNEA)</strong>
                    é incluído automaticamente, dispensando a necessidade de adicionar e listar na caixa de
                    procedimentos.`, "Atenção")
            }
        },
        addProcedimento(codigoProcedimento){

            const procedimento = this.data.form.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)
            const existe = this.data.model.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)

            if (existe) {
                return false
            }

            const limite = this.data.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO
                ? this.data.model.procedimentos.length + 1 : this.data.model.procedimentos.length

            if (limite >= 20) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (procedimento) {

                const param = {
                    id: procedimento.id,
                    nome: procedimento.nome,
                    codigo: procedimento.codigo,
                    origem: 'atencaoBasica'
                }

                this.data.model.procedimentos.push(this.clone(param))
            }
        },
        removeAfericaoPressaoArterial() {

            const condicaoAvaliada = this.data.model.atendimento.condicaoAvaliada ?
                this.data.model.atendimento.condicaoAvaliada.find(condicao => condicao
                    == this.enums.condicaoAvaliada.HIPERTENSAO) : null

            const ciap1 = this.data.model.atendimento.ciap1
                && Object.values(this.enums.ciapHipertensao).includes(this.data.model.atendimento.ciap1.id)

            const ciap2 = this.data.model.atendimento.ciap2
                && Object.values(this.enums.ciapHipertensao).includes(this.data.model.atendimento.ciap2.id)

            const cid1 = this.data.model.atendimento.cid1
                && Object.values(this.enums.cidHipertensao).includes(this.data.model.atendimento.cid1.id)

            const cid2 = this.data.model.atendimento.cid2
                && Object.values(this.enums.cidHipertensao).includes(this.data.model.atendimento.cid2.id)

            const index = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                == this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)

            const pressaoArterial = this.data.model.atendimento.pressaoArterial

            if (index >= 0 && !condicaoAvaliada && !ciap1 && !ciap2 && !cid1 && !cid2 && !pressaoArterial) {
                this.data.model.procedimentos.splice(index, 1)
            }
        }
    },
    mixins: [ repository, object, formats, mask, data ],
    props: {
        data: { type: Object, required: false },
        isAmbulatorio: { type: Boolean, default: false },
    },
    watch: {
        'data.model.atendimento.dum': function (dum) {

            if (dum) {

                this.getGestacao()
                this.getDataProvavelParto()
            } else{
                this.resetGestante()
            }
        },
        'data.model.atendimento.condicaoAvaliada': function (condicaoAvaliada) {

            if (condicaoAvaliada.find(condicao => condicao == this.enums.condicaoAvaliada.HIPERTENSAO)) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'data.model.atendimento.pressaoArterial': function (pressaoArterial) {

            if (pressaoArterial) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'data.model.atendimento.peso': function (peso) {

            if (peso) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)

                if (this.data.model.atendimento.altura) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_PESO)

                if (index >= 0) {
                    this.data.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.data.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'data.model.atendimento.altura': function (altura) {

            if (altura) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (this.data.model.atendimento.peso) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (index >= 0) {
                    this.data.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.data.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'data.model.atendimento.temperatura': function (febre) {

            if (febre) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            } else {

                const index = this.data.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_DE_TEMPERATURA)

                if (index >= 0) {
                    this.data.model.procedimentos.splice(index, 1)
                }
            }
        },
        'data.model.atendimento.ciap1': function (ciap1) {

            if (ciap1 && (ciap1.id == this.enums.ciapHipertensao.HIPERTENSAO_COM_COMPLICACOES
                || ciap1.id == this.enums.ciapHipertensao.TOXEMIA_GRAVIDICA_DHEG)) {

                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'data.model.atendimento.ciap2': function (ciap2) {

            if (ciap2 && (ciap2.id == this.enums.ciapHipertensao.HIPERTENSAO_COM_COMPLICACOES
                || ciap2.id == this.enums.ciapHipertensao.TOXEMIA_GRAVIDICA_DHEG)) {

                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'data.model.atendimento.cid1': function (cid1) {

            if (cid1 && Object.values(this.enums.cidHipertensao).includes(cid1.id)) {

                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'data.model.atendimento.cid2': function (cid2) {

            if (cid2 && Object.values(this.enums.cidHipertensao).includes(cid2.id)) {

                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
    }
}
</script>